The upper limit of webhook attempts to return from the end of the list.

Excess webhook attempts will be trimmed from the start of the list.

`first` and `last` cannot be specified in the same query.
